import moment from "moment";

export default function parseStrictDate(input: string): Date {
  const allowedFormats = [
    "MM-DD-YYYY",
    "MM/DD/YYYY",
    "YYYY-MM-DD",
    "YYYY/MM/DD",
    "MMM DD, YYYY",
    "MMMM DD, YYYY",
    "DD-MM-YYYY",
    "DD/MM/YYYY",
  ];

  const parsed = moment(input, allowedFormats, true); // `true` = strict parsing

  if (!parsed.isValid()) {
    throw new Error(`Invalid date format: "${input}". Expected one of: ${allowedFormats.join(", ")}`);
  }

  return parsed.toDate();
}
